export default {
  LOGIN_OR_REGISTER_LOADING: 'LOGIN_OR_REGISTER_LOADING',
  LOGIN_OR_REGISTER_SUCCESS: 'LOGIN_OR_REGISTER_SUCCESS',
  LOGIN_OR_REGISTER_FAILED: 'LOGIN_OR_REGISTER_FAILED',
  LOGIN_OR_REGISTER_REJECT: 'LOGIN_OR_REGISTER_REJECT',

  REGISTER_NEW_USER_LOADING: 'REGISTER_NEW_USER_LOADING',
  REGISTER_NEW_USER_SUCCESS: 'REGISTER_NEW_USER_SUCCESS',
  REGISTER_NEW_USER_FAILED: 'REGISTER_NEW_USER_FAILED',
  REGISTER_NEW_USER_REJECT: 'REGISTER_NEW_USER_REJECT',

  SEND_VERIFICATION_CODE_LOADING: 'SEND_VERIFICATION_CODE_LOADING',
  SEND_VERIFICATION_CODE_SUCCESS: 'SEND_VERIFICATION_CODE_SUCCESS',
  SEND_VERIFICATION_CODE_FAILED: 'SEND_VERIFICATION_CODE_FAILED',
  SEND_VERIFICATION_CODE_REJECT: 'SEND_VERIFICATION_CODE_REJECT',

  LOGIN_BY_VERIFICATION_CODE_LOADING: 'LOGIN_BY_VERIFICATION_CODE_LOADING',
  LOGIN_BY_VERIFICATION_CODE_SUCCESS: 'LOGIN_BY_VERIFICATION_CODE_SUCCESS',
  LOGIN_BY_VERIFICATION_CODE_FAILED: 'LOGIN_BY_VERIFICATION_CODE_FAILED',
  LOGIN_BY_VERIFICATION_CODE_REJECT: 'LOGIN_BY_VERIFICATION_CODE_REJECT',

  LOGIN_BY_PASSWORD_LOADING: 'LOGIN_BY_PASSWORD_LOADING',
  LOGIN_BY_PASSWORD_SUCCESS: 'LOGIN_BY_PASSWORD_SUCCESS',
  LOGIN_BY_PASSWORD_FAILED: 'LOGIN_BY_PASSWORD_FAILED',
  LOGIN_BY_PASSWORD_REJECT: 'LOGIN_BY_PASSWORD_REJECT',

  SET_PASSWORD_LOADING: 'SET_PASSWORD_LOADING',
  SET_PASSWORD_FAILED: 'SET_PASSWORD_FAILED',
  SET_PASSWORD_REJECT: 'SET_PASSWORD_REJECT',
  SET_PASSWORD_SUCCESS: 'SET_PASSWORD_SUCCESS',

  CHANGE_PASSWORD_LOADING: 'CHANGE_PASSWORD_LOADING',
  CHANGE_PASSWORD_FAILED: 'CHANGE_PASSWORD_FAILED',
  CHANGE_PASSWORD_REJECT: 'CHANGE_PASSWORD_REJECT',
  CHANGE_PASSWORD_SUCCESS: 'CHANGE_PASSWORD_SUCCESS',

  FORGET_PASSWORD_LOADING: 'FORGET_PASSWORD_LOADING',
  FORGET_PASSWORD_FAILED: 'FORGET_PASSWORD_FAILED',
  FORGET_PASSWORD_REJECT: 'FORGET_PASSWORD_REJECT',
  FORGET_PASSWORD_SUCCESS: 'FORGET_PASSWORD_SUCCESS',
};
